import axios from './axiosInstance';
import axiosLib from 'axios';
import { APIResort, APITerrainPark } from '../../types';
import { APISanitizedUser } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface GetOfficialUserParams extends SportAreaParams {
  userId: string;
}

interface GetTerrainParksParams extends SportAreaParams {
  abortSignal?: AbortSignal;
}

const getResort = ({ sport, areaId }: SportAreaParams): Promise<APIResort | void> => {
  return axios.get(`/${sport}/areas/${areaId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getTerrainParks = ({ sport, areaId, abortSignal }: GetTerrainParksParams): Promise<APITerrainPark[] | void> => {
  const CancelToken = axiosLib.CancelToken;
  const source = CancelToken.source();
  if (abortSignal) {
    abortSignal.addEventListener('abort', () => {
      source.cancel('Operation canceled by the user.');
    });
  }

  return axios.get(`/${sport}/areas/${areaId}/terrainparks`, { cancelToken: source.token })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

// The terrain-park list answered as it came: request errors propagate (with
// their `response.status`) and a missing body is `undefined`, never `[]`. For
// the SWR resource (`src/data/terrainParks.ts`), which must tell a 403 (not
// retried) from a transient failure, and neither from an empty resort.
const getTerrainParksStrict = ({ sport, areaId }: SportAreaParams): Promise<APITerrainPark[] | undefined> => {
  return axios.get(`/${sport}/areas/${areaId}/terrainparks`)
    .then((response) => response?.data);
};

const getOfficialUsers = ({ sport, areaId }: SportAreaParams): Promise<APISanitizedUser[]> => {
  return axios.get(`/${sport}/areas/${areaId}/users`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getOfficialUser = ({ sport, areaId, userId }: GetOfficialUserParams): Promise<APISanitizedUser> => {
  return axios.get(`/${sport}/areas/${areaId}/users/${userId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const resortFunctions = {
  getResort,
  getTerrainParks,
  getTerrainParksStrict,
  getOfficialUsers,
  getOfficialUser,
};

export default resortFunctions;
